import _ from 'lodash';
import type { PatientModeState } from '../store/reducers/patientMode';

export function inPatientMode(patientModeState: PatientModeState) {
  return _.includes(['IN_PATIENT_MODE', 'SHOW_EXIT_DIALOG'], patientModeState);
}
